exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-563f5e1f] .el-form-item__label{text-align:right}[data-v-563f5e1f] .el-card__body{height:100%}", ""]);

// exports
